export default {
  namespaced: true,

  state: {
    selected: null
  },

  actions: {
    select({ commit, dispatch }, { mod }) {
      commit('SELECT', { mod })
      dispatch('editor/appendable', null, { root: true })
    },

    unselect({ commit, dispatch }) {
      commit('UNSELECT')
      dispatch('editor/unappendable', null, { root: true })
    },

    reset({ commit, dispatch }) {
      dispatch('unselect')
      commit('RESET')
    }
  },

  mutations: {
    SELECT(state, { mod }) {
      state.selected = mod
    },

    UNSELECT(state) {
      state.selected = null
    },

    RESET(state) {
      state.selected = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/editor/mods.js